import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, Heart } from 'lucide-react';
const testimonials = [{
  photo: 'https://randomuser.me/api/portraits/women/65.jpg',
  name: 'Sofía Herrera',
  location: 'Mamá de Tomás, 6 años — Buenos Aires',
  plan: 'Plan Premium',
  text: 'La primera semana mi hijo señaló la ficha del baño solo. Llevábamos 3 años sin poder anticipar ese momento. Lloré durante 10 minutos seguidos.'
}, {
  photo: 'https://randomuser.me/api/portraits/men/52.jpg',
  name: 'Diego Paredes',
  location: 'Papá de Lucía, 8 años — Córdoba',
  plan: 'Plan Base',
  text: 'Le entregué el Manual Escolar a la maestra en marzo. En julio me llamó para decirme que era el alumno que más había progresado en el año. El manual cambió cómo ella lo veía.'
}, {
  photo: 'https://randomuser.me/api/portraits/women/12.jpg',
  name: 'Romina Acosta',
  location: 'Mamá de Mateo, 5 años — Rosario',
  plan: 'Plan Base',
  text: 'Antes de los pictogramas, las mañanas eran una batalla. Ahora mi hijo sigue la agenda visual solo y yo tengo 20 minutos extra. Eso parece una tontería pero para mí es todo.'
}, {
  photo: 'https://randomuser.me/api/portraits/women/29.jpg',
  name: 'Lucía Medina',
  location: 'Mamá de Santiago, 7 años — Mendoza',
  plan: 'Plan Premium',
  text: 'El Recetario TEA fue el que más me sorprendió. Mi hijo probó la compota de manzana en la semana 2. Llevaba 2 años comiendo exactamente 4 cosas.'
}, {
  photo: 'https://randomuser.me/api/portraits/women/90.jpg',
  name: 'Gabriela Torres',
  location: 'Mamá de Benjamín, 9 años — La Plata',
  plan: 'Plan Premium',
  text: 'El Protocolo de Paz lo imprimí y lo pegué en la heladera. La tercera noche que lo usé la crisis duró 8 minutos en lugar de 2 horas. Ocho minutos.'
}];
export function TestimonialsBottom() {
  return <section className="py-12 md:py-16 bg-stone-50" data-id="element-259">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-260">
        <div className="text-center mb-8 flex flex-col items-center" data-id="element-261">
          <Heart className="w-8 h-8 text-coral-500 mb-4 fill-current" data-id="element-262" />
          <h2 className="text-3xl font-bold text-teal-900" data-id="element-263">
            MÁS FAMILIAS QUE YA LO TIENEN
          </h2>
        </div>

        <div className="space-y-6" data-id="element-264">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-lg shadow-stone-200/50 border border-stone-100" data-id="element-265">
              <div className="flex text-amber-500 mb-4" data-id="element-266">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-267" />)}
              </div>

              <p className="text-stone-700 text-lg leading-relaxed mb-6 italic" data-id="element-268">
                "{t.text}"
              </p>

              <div className="flex items-center justify-between border-t border-stone-100 pt-4" data-id="element-269">
                <div className="flex items-center" data-id="element-270">
                  <img src={t.photo} alt={`Foto de ${t.name}`} width={40} height={40} loading="lazy" decoding="async" className="w-10 h-10 rounded-full object-cover mr-3 flex-shrink-0 ring-2 ring-stone-100" data-id="element-271" />
                  <div data-id="element-272">
                    <div className="font-bold text-teal-900 text-sm" data-id="element-273">
                      {t.name}
                    </div>
                    <div className="text-xs text-stone-500" data-id="element-274">
                      📍 {t.location}
                    </div>
                  </div>
                </div>
                <div className="bg-stone-100 text-stone-600 text-xs font-bold px-3 py-1 rounded-full" data-id="element-275">
                  {t.plan}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}